import React from 'react';
import HeroSection from './HeroSection';
import LearnFromRob from './LearnFromRob';
import Tools from './Tools';
import WhyUs from './WhyUs';
const AboutUsPage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <LearnFromRob />
      <Tools />
      <WhyUs />
    </>
  );
};

export default AboutUsPage;
